import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErzeugungsanlageService } from '../../../service/erzeugungsanlage/erzeugungsanlage.service';
import { inject, Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class TechnischeResourceIdUnique {

    private erzeugungsanlageService = inject(ErzeugungsanlageService);

    validate(dokumentenId?: string): AsyncValidatorFn {
        return (control: AbstractControl): Observable<ValidationErrors | null> => {
            if (control.value?.length == 11) {
                return this.erzeugungsanlageService.isTechnischeResourceIdUnique(
                    control.value,
                    dokumentenId,
                ).pipe(
                    map(isUnique => (isUnique ? null : { technischeResourceIdNotUnique: true })),
                    catchError(() => {
                        console.error('Error while checking if technischeResourceId is unique');
                        return of({ technischeResourceIdNotUnique: true });
                    }),
                );
            }
            return of(null);
        };
    }
}
